import React, { useState } from "react";
import { ExternalLink, ShieldCheck, X } from "lucide-react";
import Dns_img from "../assets/Duns_img.gif";

const DunsSeal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dunsUrl =
    "https://dunsregistered.dnb.com/DunsRegisteredProfileAnywhere.aspx?Key1=3182205&PaArea=Email";

  return (
    <div className="fixed right-3 top-1/2 z-50 flex -translate-y-1/2 items-center gap-3 sm:right-5">
      {isOpen && (
        <div
          id="duns-verification-panel"
          className="w-48 rounded-2xl border border-emerald-100 bg-white p-3 shadow-2xl shadow-slate-900/20"
        >
          <div className="mb-2 flex items-center justify-between gap-2">
            <p className="text-xs font-black uppercase tracking-[0.12em] text-emerald-700">
              Verified DUNS
            </p>
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="grid h-7 w-7 place-items-center rounded-full bg-slate-100 text-slate-500 transition hover:bg-slate-200 hover:text-slate-900"
              aria-label="Close DUNS verification"
            >
              <X size={15} />
            </button>
          </div>

          <a
            href={dunsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group block rounded-xl border border-slate-100 bg-slate-50 p-3 text-center transition hover:-translate-y-0.5 hover:border-emerald-200 hover:bg-emerald-50"
            aria-label="Open EV91 DUNS verification"
          >
            <img
              src={Dns_img}
              alt="D-U-N-S Registered Seal"
              className="mx-auto h-24 w-24 object-contain transition group-hover:scale-105"
            />
            <span className="mt-2 inline-flex items-center justify-center gap-1 text-xs font-bold text-emerald-800">
              Open verification <ExternalLink size={13} />
            </span>
          </a>
        </div>
      )}

      <button
        type="button"
        onClick={() => setIsOpen((value) => !value)}
        className="flex h-12 items-center gap-2 rounded-full border border-emerald-100 bg-white px-3 text-sm font-black text-emerald-800 shadow-xl shadow-slate-900/15 transition hover:-translate-y-0.5 hover:bg-emerald-50 sm:px-4"
        aria-expanded={isOpen}
        aria-controls="duns-verification-panel"
      >
        <ShieldCheck size={20} />
        <span className="hidden sm:inline">Verify DUNS</span>
        <span className="sm:hidden">DUNS</span>
      </button>
    </div>
  );
};

export default DunsSeal;
